enum LS {
  THEME = 'theme',
  AUTH = 'auth',
  DEVICE_ID = 'deviceID',
  MESSAGES_HASH = 'messages_hash',
  UNSENT_MESSAGES = 'unsent_messages',
}

const SAVE_ON_LOGOUT = [LS.THEME]
const keyPrefix = 'dcc_widget_'

class LocalStorage {
  scheme = window.DCC_CONFIG.ENVIRONMENT

  get<T>(key: LS): T | null {
    const value = localStorage.getItem(`${keyPrefix}${this.scheme}_${key}`)
    if (!value) return null
    return JSON.parse(value)
  }

  set(key: LS, data: IObjectData | string): void {
    localStorage.setItem(`${keyPrefix}${this.scheme}_${key}`,JSON.stringify(data))
  }

  delete(key: LS): void {
    localStorage.removeItem(`${keyPrefix}${this.scheme}_${key}`)
  }

  clear(): void {
    const enums = Object.values(LS).filter(e => !SAVE_ON_LOGOUT.includes(e))

    enums.forEach(el => {
      localStorage.removeItem(`${keyPrefix}${this.scheme}_${el}`)
    })
  }

  setObjectValue<T>(storageKey: LS, objectKey: string, value: T): void {
    const storage = this.get(storageKey) || {}
    storage[objectKey] = value
    this.set(storageKey, storage)
  }
}

export {
  LS,
}

export { LocalStorage }